





























import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class BlockBrandToolTip extends Vue {
  private show: boolean = false;

  public showModal() {
    this.show = true;
  }
}
